import { UserCard } from './UserCard/UserCard'
import store from '@/core/store'
import './UserMenu.scoped.sass'
import commonsService from '@/services/commons.service'

export function UserMenu () {
  const myInfo = store.getState().me.me

  function getUserInfo () {
    if (!commonsService.isMobile()) {
      return (
        <div className='user-menu'>
          {/* <img className='contacts-button' src="/assets/img/contacts-button.svg" /> */}
          <div className='user-basic-info'>
            <div className='user-info' title={myInfo.fullname}>
              <span className='user-name'>{myInfo.fullname}</span>
            </div>
            <div className='user-info' title={myInfo.defaultdomain}>
              <span className='user-domain'>{myInfo.defaultdomain}</span>
            </div>
          </div>
          <UserCard/>
        </div>
      )
    } else {
      return (
        <div className='user-menu'>
          {/* <img className='contacts-button' src="/assets/img/contacts-button.svg" /> */}
          <UserCard/>
        </div>
      )
    }
  }
  return (
    getUserInfo()
  )
}
